import { render, staticRenderFns } from "./DocumentViewerMenu.vue?vue&type=template&id=44dd99b7&scoped=true&"
import script from "./DocumentViewerMenu.vue?vue&type=script&lang=ts&"
export * from "./DocumentViewerMenu.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentViewerMenu.vue?vue&type=style&index=0&id=44dd99b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44dd99b7",
  null
  
)

export default component.exports